import {
  GET_NEXT_ASSIGNMENT,
  RESET_AGENT_STATE,
  SET_AUTO_DIAL,
  SET_AUTO_DIAL_CAMPAIGN,
  SET_AUTO_DIAL_PAUSED,
  SET_BROADCAST_DETAIL_TABLE_PAGE,
  SET_BROADCAST_LIST_TABLE_PAGE,
  SET_CALL_SCHEDULE_ASSIGNMENT_ID,
  SET_DIAL_MODE,
  SET_IS_SELECTING_CONTACT,
  SET_LAST_ASSIGNMENTID,
  SET_PENDING_STATUS_REASON,
  SET_SELECTED_AGENT_ID,
  SET_SELECTED_APPROVAL,
  SET_SELECTED_CHAT,
  SET_AGENT_SELECTED_ASSIGNMENT,
  SET_ASSIGNMENT_CHAT_LIST_ID,
} from "../Types/AgentTypes";

const agentState = {
  isAutoDialPaused: false,
  isInAutoDial: false,
  autoDialCampaign: {}, // For auto dial, stores last campaign data when autodial started
  pendingStatusReason: "", // Used when agent wanted to change status to AUX during auto dial
  lastAssignmentID: null, // For auto dial, stores last assignment ID to get next assignmentID
  goToNextAssignment: false, // For auto dial, to trigger useEffect function that gets the next assignment
  dialMode: "", // manual || progressive || predictive
  selectedAgentID: null, // For chat internal selected chat
  selectedApproval: null, // For contact approval notification
  callScheduleAssignmentID: null, // For showing assigment when showing call schedule details
  broadcastListTablePage: 0, // To keep broadcast list table page
  broadcastDetailTablePage: 0, // To keep broadcast detail table page
  agentSelectedAssignment: null,
  isSelectingContact: false, // Used when choosing contact from chat information header
  selectedChat: {}, // Used when choosing contact from chat information header
  assignmentChatListID: "", // Used to search chat from assignment detail
};

const initialState = JSON.parse(JSON.stringify(agentState));

export const agentReducer = (state = agentState, action) => {
  const { payload, type } = action;

  if (type === SET_AUTO_DIAL) {
    return {
      ...state,
      isInAutoDial: payload,
    };
  }

  if (type === SET_AUTO_DIAL_PAUSED) {
    return {
      ...state,
      isAutoDialPaused: payload,
    };
  }

  if (type === SET_AUTO_DIAL_CAMPAIGN) {
    return {
      ...state,
      autoDialCampaign: payload,
    };
  }

  if (type === SET_PENDING_STATUS_REASON) {
    return {
      ...state,
      pendingStatusReason: payload,
    };
  }

  if (type === SET_LAST_ASSIGNMENTID) {
    return {
      ...state,
      lastAssignmentID: payload,
    };
  }

  if (type === GET_NEXT_ASSIGNMENT) {
    return {
      ...state,
      goToNextAssignment: !state.goToNextAssignment,
    };
  }

  if (type === SET_DIAL_MODE) {
    return {
      ...state,
      dialMode: payload,
    };
  }

  if (type === RESET_AGENT_STATE) {
    state = initialState;
    return { ...state };
  }

  if (type === SET_SELECTED_AGENT_ID) {
    return {
      ...state,
      selectedAgentID: payload,
    };
  }

  if (type === SET_SELECTED_APPROVAL) {
    return {
      ...state,
      selectedApproval: payload,
    };
  }

  if (type === SET_CALL_SCHEDULE_ASSIGNMENT_ID) {
    return {
      ...state,
      callScheduleAssignmentID: payload,
    };
  }

  if (type === SET_BROADCAST_LIST_TABLE_PAGE) {
    return {
      ...state,
      broadcastListTablePage: payload,
    };
  }

  if (type === SET_BROADCAST_DETAIL_TABLE_PAGE) {
    return {
      ...state,
      broadcastDetailTablePage: payload,
    };
  }

  if (type === SET_AGENT_SELECTED_ASSIGNMENT) {
    return {
      ...state,
      agentSelectedAssignment: payload,
    };
  }

  if (type === SET_IS_SELECTING_CONTACT) {
    return {
      ...state,
      isSelectingContact: payload,
    };
  }

  if (type === SET_SELECTED_CHAT) {
    return {
      ...state,
      selectedChat: payload,
    };
  }

  if (type === SET_ASSIGNMENT_CHAT_LIST_ID) {
    return {
      ...state,
      assignmentChatListID: payload,
    };
  }

  return state;
};
